var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Actor } from '../actor/Actor';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { editable, editObservable } from '../../utils/mobx/decorators/editable';
import { runtime } from '../runtime/Runtime';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { child } from '../../utils/serializr/serializr';
import { BundleStore } from './modules/BundleStore';
import { PersistActor } from '../actor/PersistActor';
export class Bundle extends PersistActor {
    name = '';
    stencil = '';
    description = '';
    questions = 0;
    appSignals = '';
    assetSize = 0;
    measuredAssetSize = 0;
    bundleSize = 0;
    type = 'bundle';
    bundleStore;
    constructor(init) {
        super(init);
        editObservable(this);
    }
    get readableIdentifier() {
        return `bundle_${this.name}`;
    }
    get bundleEdit() {
        return new runtime.solidPackages.Edit.classes.BundleEdit(this);
    }
    get previewImageSrc() {
        return this.ownAspect.preview.aspectContent.regional.primaryOfKey('image').img.srcWithoutHost;
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                name: true,
                stencil: true,
                description: true,
                questions: true,
                appSignals: true,
                bundleStore: withInit(child(BundleStore), {}),
                assetSize: true,
                bundleSize: true,
            },
            afterDeserialize: async ({ target, context }) => {
                if (runtime.runtimePermissions.hasEditFunctionality) {
                    const bundle = target;
                    runtime.runtimeScheduler.addToNextIdleStateChange(() => (bundle.assetSize = bundle.measuredAssetSize));
                }
            },
        };
    }
}
__decorate([
    editable()
], Bundle.prototype, "name", void 0);
__decorate([
    editable()
], Bundle.prototype, "stencil", void 0);
__decorate([
    editable()
], Bundle.prototype, "description", void 0);
__decorate([
    editable()
], Bundle.prototype, "appSignals", void 0);
__decorate([
    editable()
], Bundle.prototype, "assetSize", void 0);
__decorate([
    editable()
], Bundle.prototype, "bundleSize", void 0);
__decorate([
    memoize
], Bundle.prototype, "bundleEdit", null);
__decorate([
    memoize
], Bundle, "serializeInfo", null);
